import { Box, Checkbox, Typography } from '@mui/material';
import AutocolonList from 'app/components/AutocolonList';
import { divisionAutocolnSortedItemsTransportSelector } from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { checklistAutocolonDelete, checklistAutocolonPush, checklistAutocolonsDelete, checklistAutocolonsListDelete, checklistAutocolonsPush, templateAutocolonsLoad, } from 'app/store/checklist';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
const ChecklistTemplateAutocolonList = () => {
    const { templateSelectedItem } = useSelector((state) => state.checklist);
    const { asyncAction: fetchDataAutoclons, isLoading: isFetchAutoclonsLoading } = useAsyncAction(templateAutocolonsLoad, [
        templateSelectedItem,
    ]);
    useEffect(() => {
        fetchDataAutoclons(templateSelectedItem.id);
    }, [templateSelectedItem.id]);
    const { autocolons: autocolonCheckedItems = [], id } = templateSelectedItem;
    const { asyncAction: deleteGroup, isLoading: isDeleteGroup } = useAsyncAction(checklistAutocolonsListDelete, [templateSelectedItem]);
    const { asyncAction: deleteAll, isLoading: isDeleteAll } = useAsyncAction(checklistAutocolonsDelete, [templateSelectedItem]);
    const { asyncAction: addGroup, isLoading: isAddGroup } = useAsyncAction(checklistAutocolonsPush, [templateSelectedItem]);
    const { asyncAction: pushSubmit, isLoading: isPushSubmit } = useAsyncAction(checklistAutocolonPush, [templateSelectedItem]);
    const { asyncAction: deleteSubmit, isLoading: isDeleteSubmit } = useAsyncAction(checklistAutocolonDelete, [templateSelectedItem]);
    const divisions = useSelector(divisionAutocolnSortedItemsTransportSelector);
    const items = divisions.reduce((acc, division) => {
        const autocolons = division.autocolons.map((autocolon) => {
            return Object.assign(Object.assign({}, autocolon), { checked: autocolonCheckedItems.includes(autocolon.id) });
        });
        const divisionChecked = autocolons.filter((item) => !item.checked).length === 0;
        acc.push(Object.assign(Object.assign({}, division), { autocolons, checked: divisionChecked }));
        return acc;
    }, []);
    const isCheckedAll = items.filter((division) => !division.checked).length === 0;
    const handleItemClick = (value) => {
        value.checked ? deleteSubmit(id, value.id) : pushSubmit(id, value.id);
    };
    const handleCheckAll = () => {
        if (isAddGroup || isDeleteGroup)
            return;
        if (isCheckedAll) {
            deleteAll(id);
        }
        else {
            const list = items.reduce((acc, { autocolons }) => {
                const unchecked = autocolons.filter((item) => !item.checked).map((item) => item.id);
                acc = acc.concat(unchecked);
                return acc;
            }, []);
            addGroup(id, list);
        }
    };
    const handleCheckAllDivision = (e, { autocolons, checked }) => {
        e.stopPropagation();
        e.preventDefault();
        if (isAddGroup || isDeleteGroup)
            return;
        if (checked) {
            deleteGroup(templateSelectedItem.id, autocolons.map((item) => item.id));
        }
        else {
            addGroup(templateSelectedItem.id, autocolons.filter((item) => !item.checked).map((item) => item.id));
        }
    };
    const startExpanded = items.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
    }, {});
    const [expanded, setExtended] = useState(startExpanded);
    const handleAccordionChange = (key) => {
        setExtended(Object.assign(Object.assign({}, expanded), { [key]: !expanded[key] }));
    };
    const isCheckboxDisabled = isDeleteSubmit || isPushSubmit || isAddGroup || isDeleteGroup || isFetchAutoclonsLoading || isDeleteAll;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                textAlign: 'end',
                paddingRight: '24px',
                cursor: 'pointer',
                font: 'inherit',
            }, onClick: handleCheckAll },
            React.createElement(Typography, { component: 'span' }, "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0451"),
            React.createElement(Checkbox, { size: 'small', edge: 'end', disableRipple: true, checked: isCheckedAll, disabled: isCheckboxDisabled })),
        React.createElement(AutocolonList, { isCheckboxDisabled: isCheckboxDisabled, items: items, expanded: expanded, handleAccordionChange: handleAccordionChange, handleItemClick: handleItemClick, handleCheckAllDivision: handleCheckAllDivision })));
};
export default ChecklistTemplateAutocolonList;
